




















































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

interface GCS {
  e: number;
  v: number;
  m: number;
}

@Component
export default class AsesmenLain extends Vue {
  @Prop() readonly risjatVal: number;
  @Prop() readonly kecemasanVal: number;
  @Prop() readonly gcsVal: GCS;

  selectProps = { openOnHover: true, offsetY: true };

  asesRisjat = null;
  asesKecemasan = null;

  gcsEye = null;
  gcsVerbal = null;
  gcsMotor = null;

  set gcs(val: GCS) {
    this.gcsEye = Number(val.e);
    this.gcsVerbal = Number(val.v);
    this.gcsMotor = Number(val.m);
  }

  get gcs(): GCS {
    return {
      e: this.gcsEye,
      v: this.gcsVerbal,
      m: this.gcsMotor
    };
  }

  @Watch("gcsVal", { deep: true })
  changeGcsVal(val: GCS) {
    this.gcs = val;
  }

  @Watch("gcs", { deep: true })
  changeGcs(val: GCS) {
    this.$emit("setGcs", val);
  }

  @Watch("risjatVal")
  changeRisjatVal(val: number | string) {
    this.asesRisjat = Number(val);
  }

  @Watch("kecemasanVal")
  changeKecemasanVal(val: number | string) {
    this.asesKecemasan = Number(val);
  }

  @Watch("asesRisjat")
  changeAsesRisjat(val: number) {
    this.$emit("setRisikoJatuh", val);
  }

  @Watch("asesKecemasan")
  changeAsesKecemasan(val: number) {
    this.$emit("setKecemasan", val);
  }

  gcsEyeOptions = [
    { id: 1, name: "Tidak membuka mata" },
    { id: 2, name: "Dengan rangsangan nyeri" },
    { id: 3, name: "Dengan perintah suara" },
    { id: 4, name: "Spontan" },
    { id: 0, name: "NT" }
  ];
  gcsVerbalOptions = [
    { id: 1, name: "Tidak bersuara" },
    { id: 2, name: "Mengerang" },
    { id: 3, name: "Kata" },
    { id: 4, name: "Orientasi abnormal" },
    { id: 5, name: "Kalimat lengkap dan orientasi baik" },
    { id: 0, name: "NT" }
  ];
  gcsMotorOptions = [
    { id: 1, name: "Tidak bergerak" },
    { id: 2, name: "Response ekstensi abnormal" },
    { id: 3, name: "Response fleksi abnormal" },
    { id: 4, name: "Menjauhi nyeri" },
    { id: 5, name: "Melokalisir nyeri" },
    { id: 6, name: "Sesuai perintah" },
    { id: 0, name: "NT" }
  ];
  levelKesadaran = [
    { maxVal: 15, text: "Composmentis" },
    { maxVal: 13, text: "Apatis" },
    { maxVal: 11, text: "Delirium" },
    { maxVal: 9, text: "Somnolen" },
    { maxVal: 6, text: "Sopor" },
    { maxVal: 4, text: "Semi Coma" },
    { maxVal: 3, text: "Coma" }
  ];
  asesRisjatOptions = [
    { id: 0, name: "Tidak Berisiko" },
    { id: 1, name: "Risiko Sedang" },
    { id: 2, name: "Risiko Tinggi" }
  ];
  asesKecemasanOptions = [
    { id: 0, name: "Tidak" },
    { id: 1, name: "Ringan" },
    { id: 2, name: "Sedang" },
    { id: 3, name: "Berat" }
  ];

  get gcsEyeOpts() {
    return this.gcsEyeOptions.slice().sort((a, b) => b.id - a.id);
  }

  get gcsVerbalOpts() {
    return this.gcsVerbalOptions.slice().sort((a, b) => b.id - a.id);
  }

  get gcsMotorOpts() {
    return this.gcsMotorOptions.slice().sort((a, b) => b.id - a.id);
  }

  get kesadaranDescription() {
    const gcs = this.gcsEye + this.gcsVerbal + this.gcsMotor;

    const val = this.levelKesadaran
      .slice()
      .sort((a, b) => a.maxVal - b.maxVal)
      .find(item => gcs <= item.maxVal);

    return val && this.gcsEye && this.gcsVerbal && this.gcsMotor
      ? val.text
      : "-";
  }
}
